export default "__VITE_ASSET__ee1893b3__"